import { DiscoveryNavProvider } from "providers/DiscoveryNavProvider";
import type { FC } from "react";
import { Outlet } from "react-router-dom";

/**
 * Wraps the discovery pages (StartPage, SearchPage) so the discovery nav's
 * config, held by DiscoveryNavProvider, persists across navigation between
 * them — this route element stays mounted while <Outlet/> swaps its
 * children. Each page still renders its own DiscoveryNavOutlet wherever it
 * wants the bar to appear.
 */
export const DiscoveryLayout: FC = () => (
  <DiscoveryNavProvider>
    <Outlet />
  </DiscoveryNavProvider>
);
